module.exports = __webpack_public_path__ + "media/images/google-5699728edd7a1e80be5370bb592d5cd5.svg";